/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from "react";

import { INavLinks } from "components/HeaderNavBar/type";
import { ScrollToTopButton } from "./ScrollToTopButton";
import { t, Trans } from "@lingui/macro";

import * as styles from "./SubFooter.module.scss";
import { InputForm } from "@silversea-ssc/ui-components-react";

interface SubFooter {
  links: INavLinks;
  searchUrl: string;
}

const SubFooter: FC<SubFooter> = ({ links, searchUrl }) => {
  const year = new Date().getFullYear();

  return (
    <div>
      <div className={styles.subFooterContainer}>
        <div className={styles.copyright}>@ {year} SILVERSEA CRUISES LTD.</div>
        <div className={styles.subFooterNav}>
          <ul>
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href}>{l.title}</a>
              </li>
            ))}
            <li>
              <button
                id="ot-sdk-btn"
                className={`${styles.onetrustButton} ot-sdk-show-settings`}
              >
                <Trans>Cookie Settings</Trans>
              </button>
            </li>
          </ul>
        </div>

        <ScrollToTopButton />
        <div data-content-piece="nav_search" className={styles.searchContainer}>
          <label htmlFor="sub-footer-search" className="sr-only">
            <Trans>Search input placeholder</Trans>
          </label>
          <InputForm
            id="sub-footer-search"
            className={styles.search}
            name="query"
            placeholder={t`Search input placeholder`}
            formAction={searchUrl}
            inputType="search"
            icon="search"
            variant="transparent"
            buttonVariant="white"
          />
        </div>
      </div>
    </div>
  );
};

export default SubFooter;
